var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-text"},[(_vm.item.data)?_c('van-cell',{attrs:{"center":"","title":_vm.item.title,"label":_vm.item.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }